module.exports = __webpack_public_path__ + "static/media/MDX-BUSD.72cae641.png";